import { render, staticRenderFns } from "./childResult.vue?vue&type=template&id=6a4e2b2e&scoped=true&"
import script from "./childResult.vue?vue&type=script&lang=js&"
export * from "./childResult.vue?vue&type=script&lang=js&"
import style0 from "./childResult.vue?vue&type=style&index=0&id=6a4e2b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e2b2e",
  null
  
)

component.options.__file = "childResult.vue"
export default component.exports